<template>
  <div class="main-container">
    <button
      @click="selectedTab = 'INSTANT'"
      :class="selectedTab == 'INSTANT' ? 'selected' : ''"
    >
      {{ $t("requestsPage.instantOrders") }}
    </button>
    <button
      @click="selectedTab = 'RESERVATION'"
      :class="selectedTab == 'RESERVATION' ? 'selected' : ''"
      style="margin-inline-start: 10px"
    >
      {{ $t("requestsPage.reservation") }}
    </button>

    <!-- <PhoneOrders style="margin-left: 10px; float: right"></PhoneOrders> -->
     <router-link v-if="hasPermission('CREATE_BOOKING')"  :to="{ name: 'CreateBooking' }"><button  class="phone-booking-button">{{ $t("requestsPage.newBooking") }}</button></router-link>
    <component :is="selectedTab"></component>
  </div>
</template>

<script>
import InstantOrders from "@/components/dispatching/InstantOrders.vue";
import ReservationOrders from "@/components/dispatching/ReservationOrders.vue";

export default {
  name: "Requests",
  title() {
    return this.$t("requestsPage.pageTitle");
  },
  components: {
    INSTANT: InstantOrders,
    RESERVATION: ReservationOrders
  },
  data() {
    return {
      selectedTab: "INSTANT",
    };
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: 100%;
  padding: 28px 36px;
  float: inline-start;
  font-family: Poppins !important;

  button {
    float: inline-start;
    padding: 14px 20px;
    border-radius: 8px;
    box-shadow: 0px 0px 6px rgba(0, 11, 138, 0.08);
    background: white;
    outline: none;

    &.selected {
      box-shadow: inset 0px 0px 0px 1px #27a432;
    }
  }

  .phone-booking-button {
    float: inline-end;
    background: #27a432;
    color: white;
  }
}
</style>
